import { Outlet, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "./common/Sidebar";
import Header from "./common/Header";
// import { useAuth } from "../store/hooks/useAuth";

const DESKTOP_BREAKPOINT = 1024;

/* Added by Farhan Khan on 12-Feb-2026 - CRM layout: sidebar fixed left, header top, content fills remaining space, no extra white space */
export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isDesktop, setIsDesktop] = useState(true);
  // const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const check = () => {
      const desktop = window.innerWidth >= DESKTOP_BREAKPOINT;
      setIsDesktop(desktop);
      if (!desktop) setSidebarOpen(false);
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const handleLogout = () => {
    // logout();
    navigate("/login");
  };

  const sidebarVisible = isDesktop ? sidebarOpen : false;
  const sidebarOpenForMobile = sidebarOpen;

  return (
    <div className="crm-layout">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        isDesktop={isDesktop}
      />

      {sidebarOpenForMobile && !isDesktop && (
        <div
          className="crm-sidebar-overlay crm-sidebar-overlay--visible"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <div
        className={`crm-main ${!sidebarVisible ? "crm-main--fullwidth" : ""}`}
      >
        <Header
          onLogout={handleLogout}
          onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
        />

        <main className="crm-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}